import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/conroe")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Conroe, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Conroe & Montgomery County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Conroe, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Conroe and Montgomery County.",
      keywords: "awnings Conroe, awning company Conroe, custom awnings Conroe, sail shades Conroe, patio covers Conroe, pergola covers Conroe, metal awnings Conroe, canvas awnings Conroe, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Conroe", "Montgomery County"),
  }),
  component: () => <CityHomePage city="Conroe" region="Montgomery County" />,
});
